import { toast as sonnerToast } from 'sonner';
import { renderMuiToast } from './toastRenderer';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong, please try again';
const DEFAULT_DURATION = 5000;

import type { ToastSeverity } from './toastRenderer';

type ToastOptions = { duration?: number };

const show = (message: string, severity: ToastSeverity, options?: ToastOptions) =>
  sonnerToast.custom((id) => renderMuiToast(id, message, severity), {
    duration: options?.duration ?? DEFAULT_DURATION,
  });

export const toast = {
  success: (message: string, options?: ToastOptions) => show(message, 'success', options),

  error: (message: string = DEFAULT_ERROR_MESSAGE, options?: ToastOptions) =>
    show(message, 'error', options),

  info: (message: string, options?: ToastOptions) => show(message, 'info', options),

  loading: (message: string) => show(message, 'loading', { duration: Infinity }),

  dismiss: (id?: string | number) => sonnerToast.dismiss(id),

  promise: sonnerToast.promise,
};
